import { format, subDays } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import type { TokenUsageCopy } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

export interface UsagePeriodPreset {
  key: keyof TokenUsageCopy['presets']
  label: string
  dateFrom: string
  dateTo: string
}

const parseUsageDate = (value: string) => new Date(`${value}T12:00:00`)
const isoDate = (value: Date) => format(value, 'yyyy-MM-dd')

export function buildDateRangePresets(maxDate: string, labels: TokenUsageCopy['presets']): UsagePeriodPreset[] {
  const today = parseUsageDate(maxDate)

  return [
    { key: 'last_7_days', label: labels.last_7_days, dateFrom: isoDate(subDays(today, 6)), dateTo: maxDate },
    { key: 'last_14_days', label: labels.last_14_days, dateFrom: isoDate(subDays(today, 13)), dateTo: maxDate },
    { key: 'last_30_days', label: labels.last_30_days, dateFrom: isoDate(subDays(today, 29)), dateTo: maxDate },
  ]
}

export function formatUsageDate(value: string) {
  return format(parseUsageDate(value), 'dd/MM/yyyy', { locale: ptBR })
}
